// src/Components/GridIconGroup.js
/* eslint-disable */
import React from "react";
import { Box, CircularProgress, IconButton, Tooltip } from "@mui/material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import DownloadIcon from "@mui/icons-material/Download";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import RefreshIcon from "@mui/icons-material/Refresh";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";

export default function GridGroupIcons({
  onRefresh,
  onToggleFullscreen,
  isFullscreen,
  onDownloadCSV = () => {},
  iconsDisabled,
  downloadIcon = true,
  refreshIcon = true,
  fullScreenIcon = true,
  isDownloading = false,
  borderRadius = 19,
}) {
  const navy = "#16325C";

  return (
    <Box
      sx={{
        bgcolor: "white",
        border: "1px solid #e0e0e0",
        borderRadius: `${borderRadius}px`,
        /* no explicit padding = tall container */
        // either control via padding:
        py: 0.25, // 2px top & bottom
        px: 1, // 8px left & right
        // or hard‐code a height:
        height: 35, // 40px total
        display: "flex",
        alignItems: "center",
        gap: 1.5,
      }}
    >
      {/* Download */}
      {downloadIcon && (
        <Tooltip title="Download all records">
          <IconButton
            onClick={!isDownloading && onDownloadCSV}
            sx={{
              color: navy,
            }}
            disabled={iconsDisabled}
          >
            {isDownloading ? (
              <CircularProgress size={24} />
            ) : (
              <DownloadIcon sx={{ fontSize: 24 }} />
            )}
          </IconButton>
        </Tooltip>
      )}
      {/* Refresh */}

      {refreshIcon && (
        <Tooltip title="Reload data">
          <IconButton
            onClick={onRefresh}
            sx={{ color: navy }}
            disabled={iconsDisabled}
          >
            <RefreshIcon sx={{ fontSize: 24 }} />
          </IconButton>
        </Tooltip>
      )}

      {/* Full-screen toggle */}
      {fullScreenIcon && (
        <Tooltip title={isFullscreen ? "Exit full screen" : "Full screen"}>
          <IconButton
            onClick={onToggleFullscreen}
            sx={{
              color: navy,
            }}
          >
            {isFullscreen ? (
              <FullscreenExitIcon sx={{ fontSize: 24 }} />
            ) : (
              <FullscreenIcon sx={{ fontSize: 24 }} />
            )}
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
}
